/**
 * User: liliana
 * Date: 3/20/15
 * Time: 6:24 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

'use strict';

var SoaCollection        = require('bunsen/collections/SoaCollection');

/**
 * @class FavoriteParameters
 * @extends SoaCollection
 * @constructs FavoriteParameters object
 * @constructor
 */
var FavoriteParameters   = module.exports = SoaCollection.extend();

var _                    = require('underscore');
var FavoriteParameter    = require('bunsen/models/identity/FavoriteParameter');

_.extend(FavoriteParameters.prototype, {
    model : FavoriteParameter,

    /**
     * @param {string} key
     * @returns {FavoriteParameter}
     */
    getParamByKey : function (key) {
        return this.findWhere({ key : key });
    },

    /**
     * @param {string} key
     * @returns {string|null}
     */
    getParamDisplayValueByKey : function (key) {
        var param = this.getParamByKey(key);
        return param ? param.getDisplayValue() : null;
    }
});




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/identity/FavoriteParameters.js
// module id = 2610
// module chunks = 62